import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJalurJenis } from "@/services/getData"

export default function MasterJalurJenisPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJalurJenis"],
    queryFn: getListJalurJenis,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
